import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

const getExamBoardsSuccess = (data) => {
  const noData = isObjectEmpty(data.Data)
  return {
    type: actionTypes.GET_EXAMINATION_BOARDS,
    payload: {
      boards: noData ? [] : data.Data,
    },
  };
};

export const getExamBoards = () => async (dispatch) => {
  return await apiCall
    .axiosGet(`${API_BASE_URL}/GetBoards`)
    .then((response) => {
      if (response) {
        dispatch(getExamBoardsSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
